import { render } from "./MainConcept.vue?vue&type=template&id=4024f34e"
import script from "./MainConcept.vue?vue&type=script&lang=js"
export * from "./MainConcept.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__